// extracted by mini-css-extract-plugin
export var phone = "_3e-0";
export var phoneDragging = "_3e-1";